import MajorApi from '../../../api/src/basic/api/MajorApi'
import {message} from "ant-design-vue";

const majorApi = new MajorApi();

const state = {
    majorList: []
}

const mutations = {
    addMajorList(state, data) {
        state.majorList = data || []
    },
}

const actions = {
    // 分页获取专业
    pageMajor: async ({commit, state}, query) => {
        let result = await majorApi.page(query.pageNum,query.body);
        return result
    },
    // 添加专业
    addMajor: ({commit, state}, query) => {
        console.log(query)
        return new Promise((resolve, reject) => {
            majorApi.add(query.body).then(res => {
                resolve(res)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    // 删除课程
    delCourse: ({commit, state}, id) => {
        return new Promise((resolve, reject) => {
            majorApi.remove(id).then(res => {
                resolve(res)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    // 修改课程
    editMajor: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            majorApi.update(query.id, query.body).then(res => {
                resolve(res)
            }).catch(err => {
                this.$message.error(err.message)
                console.log(err)
            })
        })
    }
}

export default {
    // namespaced: true,
    state,
    actions,
    mutations
}